import React from 'react';
import { PopupContext } from 'ui-builder';

type ProjectDetailsActionsContextData = {
  setupAreaId: number | string
}

const SetupAreaIdReactContext = React.createContext<ProjectDetailsActionsContextData | null>(null);

export function SetupAreaIdContext(
  props: {
    data: ProjectDetailsActionsContextData,
    children: React.ReactNode
  }
) {
  return (
    <SetupAreaIdReactContext.Provider value={props.data}>
      <PopupContext>
        {props.children}
      </PopupContext>
    </SetupAreaIdReactContext.Provider>
  );
}

export function useSetupAreaIdContext() {
  return React.useContext(SetupAreaIdReactContext);
}

export function useSetupAreaIdContextRequired() {
  const context = useSetupAreaIdContext();
  if (!context) {
    throw new Error('useSetupAreaIdContextRequired must be used within a SetupAreaIdContext');
  }
  return context;
}
